import { SESSION_STORAGE_KEYS } from 'dashboard/constants/sessionStorage';
import { isDuplicateTab } from 'dashboard/helper/phoneTabGuard';

/**
 * Bring the phone back online after a reload when the agent had it connected.
 *
 * `requestConnect`/`requestDisconnect` persist the agent's choice per account
 * in sessionStorage, so a reload can restore it instead of silently leaving the
 * agent off the queues. Used by the dashboard sidebar and by the Salesforce CTI
 * panel, which Salesforce reloads on its own whenever the utility bar item is
 * re-created.
 *
 * A duplicated tab inherits the source tab's sessionStorage, including the
 * "online" flag. Auto-connecting there would register a second SIP UA for the
 * same agent and fight the original tab, so skip it. We also neutralize the
 * inherited flag so this tab won't auto-connect on its own future reloads —
 * until the user explicitly connects, which re-sets the flag via
 * `requestConnect` and will be honored on reload.
 *
 * The caller must have the SIP credentials in the store already: they are what
 * `connect` registers with.
 */
export const restorePhoneConnection = async store => {
  const accountId = store.getters.getCurrentAccountId;
  const key = SESSION_STORAGE_KEYS.USER_REQUESTED_PHONE_STATUS(accountId);
  // Read before the duplicate check, which overwrites the inherited flag.
  const userRequestedStatus = sessionStorage.getItem(key);

  if (await isDuplicateTab()) {
    sessionStorage.setItem(key, 'offline');
    return;
  }

  if (
    store.getters['phone/getStatus'] === 'offline' &&
    userRequestedStatus === 'online'
  ) {
    await store.dispatch('phone/requestConnect');
  }
};
